import { getIntl } from 'umi';

const intl = getIntl();

function getUnit(option: { num: number; singleUnit: string; multipleUnit: string }) {
  const { num, singleUnit, multipleUnit } = option;
  if (typeof num !== 'number') return '';
  return num === 0 || num === 1 ? singleUnit : multipleUnit;
}

function getDateStrFromSeconds(totalSeconds: number) {
  let totalSecondsTemp = totalSeconds;
  totalSecondsTemp = typeof totalSecondsTemp === 'number' && !Number.isNaN(totalSecondsTemp) ? totalSecondsTemp : 0;
  const hours = Math.floor(totalSecondsTemp / (60 * 60));
  const minutes = Math.floor((totalSecondsTemp % (60 * 60)) / 60);
  const seconds = totalSecondsTemp % 60;
  let list = [];
  let result = '';

  list = [
    {
      type: 'hour',
      value: hours,
      singleUnit: intl.formatMessage({ id: 'dbi_download_page_hour' }),
      multipleUnit: intl.formatMessage({ id: 'dbi_download_page_hours' }),
    },
    {
      type: 'minute',
      value: minutes,
      singleUnit: intl.formatMessage({ id: 'dbi_download_page_minute' }),
      multipleUnit: intl.formatMessage({ id: 'dbi_download_page_minutes' }),
    },
    {
      type: 'second',
      value: seconds,
      singleUnit: intl.formatMessage({ id: 'dbi_download_page_second' }),
      multipleUnit: intl.formatMessage({ id: 'dbi_download_page_seconds' }),
    },
  ];

  list.forEach((item) => {
    if (item && item.value > 0) {
      result =
        result +
        item.value +
        getUnit({
          num: item.value,
          singleUnit: item.singleUnit,
          multipleUnit: item.multipleUnit,
        });
    }
  });

  result = result.replace(/\d+/g, (numStr, i) => (i === 0 ? `${numStr} ` : ` ${numStr} `));

  return result;
}

function getWaitingTimeRangeStr(option: { minSeconds: number; maxSeconds: number }) {
  const { minSeconds, maxSeconds } = option || {};
  if (minSeconds > 0 && maxSeconds > 0) {
    return `${getDateStrFromSeconds(minSeconds)} ~ ${getDateStrFromSeconds(maxSeconds)}`;
  }
  return getDateStrFromSeconds(maxSeconds);
}

// 获取下载waiting时 等待文案
export function getDownloadWaitingMsg(option: { minSeconds: number; maxSeconds: number; total: number }) {
  const { minSeconds, maxSeconds, total } = option || {};
  // 判断下载反馈提示文案时间分界点，下载数据行数小于等于5000、大于5000  下载反馈提示文案不同
  const ROWS = 5000;

  return total === undefined || total < ROWS
    ? intl.formatMessage({ id: 'dbi_download_page_short_waitting_tips' })
    : intl.formatMessage(
        { id: 'dbi_download_page_long_waitting_tips' },
        { time: getWaitingTimeRangeStr({ minSeconds, maxSeconds }) },
      );
}
